import { create } from "zustand";

type TTaskFilters = {
  status: string;
  dueDate: Date | null;
  search: string;
  page: number;
  pageSize: number;
  archiveStatus: "all" | "active" | "archived";
};

type State = {
  formState: {
    open: boolean;
    taskId?: string;
    jobTicketId?: string;
    clientId?: string;
  };
  viewTaskState: {
    open: boolean;
    taskId?: string;
  };
  filters: TTaskFilters;
};

type Actions = {
  setFilters: (filters: Partial<TTaskFilters>) => void;
  resetFilters: () => void;
  openTaskModal: (taskId?: string, jobTicketId?: string, clientId?: string) => void;
  closeTaskModal: () => void;
  openViewTaskModal: (taskId?: string) => void;
  closeViewTaskModal: () => void;
};

const initialState: TTaskFilters = {
  status: "all",
  dueDate: null,
  search: "",
  page: 1,
  pageSize: 10,
  archiveStatus: "active",
};

export const useTaskStore = create<State & Actions>((set) => ({
  formState: {
    open: false,
  },
  viewTaskState: {
    open: false,
  },
  filters: initialState,
  setFilters: (filters: Partial<TTaskFilters>) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
  resetFilters: () => set({ filters: initialState }),
  openTaskModal: (taskId, jobTicketId, clientId) =>
    set({
      formState: {
        open: true,
        taskId,
        jobTicketId,
        clientId,
      },
    }),
  closeTaskModal: () =>
    set({
      formState: {
        open: false,
        taskId: undefined,
        jobTicketId: undefined,
        clientId: undefined,
      },
    }),
  openViewTaskModal: (taskId) =>
    set({
      viewTaskState: {
        open: true,
        taskId,
      },
    }),
  closeViewTaskModal: () =>
    set({ viewTaskState: { open: false, taskId: undefined } }),
}));
